import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'antd';

import { hideConfirm } from '@features/confirmModalSlice';
import { useT } from 'TRANSLATION';

export const ConfirmModal = () => {
  const t = useT();
  const {
    isOpen,
    title,
    message,
    confirmText,
    cancelText,
    onConfirm,
    onCancel
  } = useSelector(state => state.confirmModal);
  const dispatch = useDispatch();

  const handleConfirm = () => {
    dispatch(hideConfirm());
    onConfirm?.();
  };

  const handleCancel = () => {
    dispatch(hideConfirm());
    onCancel?.();
  };

  return (
    <Modal
      zIndex={9999}
      maskClosable={false}
      title={title || t('notification.warning')}
      visible={isOpen}
      okText={confirmText || t('button.confirm')}
      cancelText={cancelText || t('button.cancel')}
      onOk={handleConfirm}
      onCancel={handleCancel}
    >
      <p>{message}</p>
    </Modal>
  );
};
